import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import { CAPTCHA_SCRIPT_LOAD_ERROR } from '~/plugins/captcha/errors';
var WINDOW_FUNCTION_NAME = '__smartCaptchaOnloadFunction';
var CaptchaPlugin = /*#__PURE__*/function () {
  function CaptchaPlugin(_siteKey, _scriptUrl) {
    _classCallCheck(this, CaptchaPlugin);
    this._siteKey = _siteKey;
    this._scriptUrl = _scriptUrl;
  }
  return _createClass(CaptchaPlugin, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(container, _ref) {
        var _this = this;
        var hl;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              hl = _ref.hl;
              if (this._siteKey) {
                _context.next = 4;
                break;
              }
              console.error('Ошибка инициализации Captcha: не указан ключ'); // eslint-disable-line no-console
              return _context.abrupt("return");
            case 4:
              if (!this._smartCaptcha) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              _context.next = 8;
              return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.setAttribute('defer', '');
                script.setAttribute('src', "".concat(_this._scriptUrl, "?render=onload&onload=").concat(WINDOW_FUNCTION_NAME));
                script.addEventListener('error', function () {
                  document.head.removeChild(script);
                  return reject(new Error(CAPTCHA_SCRIPT_LOAD_ERROR));
                });
                window[WINDOW_FUNCTION_NAME] = function () {
                  if (window.smartCaptcha) {
                    _this._smartCaptcha = window.smartCaptcha;
                    _this._widgetId = _this._smartCaptcha.render(container, {
                      sitekey: _this._siteKey,
                      hl: hl
                    });
                    return resolve(_this._widgetId);
                  }
                  return reject(new Error('Объект window.smartCaptcha не найден'));
                };
                document.head.appendChild(script);
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init(_x, _x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "subscribeSuccess",
    value: function subscribeSuccess(callback) {
      if (!this._smartCaptcha || this._widgetId === undefined /* 0 валиден */) {
        return;
      }
      this._smartCaptcha.subscribe(this._widgetId, 'success', callback);
    }
  }, {
    key: "subscribeTokenExpired",
    value: function subscribeTokenExpired(callback) {
      if (!this._smartCaptcha || this._widgetId === undefined /* 0 валиден */) {
        return;
      }
      this._smartCaptcha.subscribe(this._widgetId, 'token-expired', callback);
    }
  }, {
    key: "subscribeNetworkError",
    value: function subscribeNetworkError(callback) {
      if (!this._smartCaptcha || this._widgetId === undefined /* 0 валиден */) {
        return;
      }
      this._smartCaptcha.subscribe(this._widgetId, 'network-error', callback);
    }
  }, {
    key: "subscribeJavascriptError",
    value: function subscribeJavascriptError(callback) {
      if (!this._smartCaptcha || this._widgetId === undefined /* 0 валиден */) {
        return;
      }
      this._smartCaptcha.subscribe(this._widgetId, 'javascript-error', callback);
    }
  }, {
    key: "reset",
    value: function reset() {
      if (!this._smartCaptcha) {
        return;
      }
      this._smartCaptcha.reset(this._widgetId);
      this._smartCaptcha = undefined;
      this._widgetId = undefined;
    }
  }]);
}();
export default defineNuxtPlugin(function () {
  var _process$env$captchaA, _process$env$captchaS;
  return {
    provide: {
      captcha: new CaptchaPlugin((_process$env$captchaA = process.env.captchaApiKey) !== null && _process$env$captchaA !== void 0 ? _process$env$captchaA : '', (_process$env$captchaS = process.env.captchaScriptUrl) !== null && _process$env$captchaS !== void 0 ? _process$env$captchaS : 'https://smartcaptcha.cloud.yandex.ru/captcha.js')
    }
  };
});